import { AttackPattern, PatternState } from '../AttackPattern.js';

/**
 * Homing Shard Volley — a Calamity-style spread of slow homing projectiles.
 * Individually dodgeable (limited turn rate), but stacks pressure alongside
 * whatever else is on screen once this unlocks at phase 1.
 *
 * `config` (damage/speed/turnRate) is per-boss tuning, supplied by data/bosses.js.
 */
export class HomingShardVolley extends AttackPattern {
  constructor({ minPhase = 1, config }) {
    super({ name: 'Homing Shard Volley', telegraphDuration: 0.45, activeDuration: 0.1, minPhase });
    this.config = config;
  }

  onBegin(_boss, player) {
    this._target = { x: player.x, y: player.y };
  }

  onActiveStart(boss, player, pool) {
    const { damage, speed, turnRate } = this.config;
    const count = 5 + boss.phase * 2;
    const baseAngle = Math.atan2(player.y - boss.y, player.x - boss.x);
    const spread = 0.9;
    for (let i = 0; i < count; i++) {
      const t = count === 1 ? 0 : (i / (count - 1)) * 2 - 1;
      const angle = baseAngle + t * spread;
      pool.fire({
        x: boss.x,
        y: boss.y,
        vx: Math.cos(angle) * speed,
        vy: Math.sin(angle) * speed,
        radius: 3,
        damage,
        color: '#c04ae0',
        lifetime: 5,
        homing: true,
        turnRate,
        target: player,
      });
    }
  }

  getVisual(boss) {
    if (this.state !== PatternState.TELEGRAPH) return null;
    return { kind: 'homingPreview', x: boss.x, y: boss.y, target: this._target ?? null, count: 5 + boss.phase * 2, color: '#c04ae0' };
  }
}
